import React from 'react';
import Icon from '../../../components/AppIcon';

const SizeFormatSelector = ({ selectedSize, onSizeSelect, className = "" }) => {
  const sizeOptions = [
    {
      id: 'letter',
      name: 'Letter (8.5" × 11")',
      description: 'US standard size, ideal for office use',
      dimensions: '216 × 279 mm',
      icon: 'FileText',
      popular: true,
      disabled: false
    },
    {
      id: 'a4',
      name: 'A4 (8.3" × 11.7")',
      description: 'Standard international size, perfect for home printing',
      dimensions: '210 × 297 mm',
      icon: 'FileText',
      disabled: false
    },
    {
      id: 'half-letter',
      name: 'Half Letter (5.5" × 8.5")',
      description: 'Pocket-friendly size for on-the-go planning',
      dimensions: '140 × 216 mm',
      icon: 'Bookmark',
      disabled: true,
      comingSoon: true
    },
    {
      id: 'a5',
      name: 'A5 (5.8" × 8.3")',
      description: 'Compact size, great for portability',
      dimensions: '148 × 210 mm',
      icon: 'Bookmark',
      disabled: true,
      comingSoon: true
    }
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sizeOptions?.map((size) => (
          <div
            key={size?.id}
            onClick={() => !size?.disabled && onSizeSelect(size?.id)}
            className={`
              relative p-6 rounded-lg border-2 transition-all duration-200
              ${size?.disabled 
                ? 'cursor-not-allowed opacity-60 bg-muted border-border' :'cursor-pointer hover:shadow-md hover:scale-[1.02]'
              }
              ${!size?.disabled && selectedSize === size?.id
                ? 'border-primary bg-primary/5 shadow-md'
                : !size?.disabled 
                  ? 'border-border bg-card hover:border-primary/50' :'border-border bg-muted'
              }
            `}
          >
            {size?.popular && !size?.disabled && (
              <div className="absolute -top-2 -right-2 bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-semibold">
                Popular
              </div>
            )}
            
            {size?.comingSoon && (
              <div className="absolute -top-2 -right-2 bg-yellow-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
                Coming Soon
              </div>
            )}
            
            <div className="flex items-center space-x-4">
              <div className={`
                w-12 h-12 rounded-lg flex items-center justify-center
                ${size?.disabled 
                  ? 'bg-muted text-muted-foreground' 
                  : selectedSize === size?.id 
                    ? 'bg-primary text-primary-foreground' 
                    : 'bg-muted text-muted-foreground'
                }
              `}>
                <Icon name={size?.icon} size={24} />
              </div>
              
              <div className="flex-1">
                <h3 className={`font-heading font-semibold mb-1 ${size?.disabled ? 'text-muted-foreground' : 'text-foreground'}`}>
                  {size?.name}
                </h3>
                <p className={`font-body text-sm mb-2 ${size?.disabled ? 'text-muted-foreground/70' : 'text-muted-foreground'}`}>
                  {size?.description}
                </p>
                <p className={`font-caption text-xs ${size?.disabled ? 'text-muted-foreground/60' : 'text-muted-foreground'}`}>
                  {size?.dimensions}
                </p>
              </div>
              
              <div className={`
                w-6 h-6 rounded-full border-2 flex items-center justify-center
                ${size?.disabled
                  ? 'border-muted-foreground/40'
                  : selectedSize === size?.id
                    ? 'border-primary bg-primary' :'border-muted-foreground'
                }
              `}>
                {selectedSize === size?.id && !size?.disabled && (
                  <Icon name="Check" size={14} color="white" />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SizeFormatSelector;